import { render, staticRenderFns } from "./flagship.vue?vue&type=template&id=9696fa8e&"
import script from "./flagship.vue?vue&type=script&lang=js&"
export * from "./flagship.vue?vue&type=script&lang=js&"
import style0 from "./flagship.vue?vue&type=style&index=0&id=9696fa8e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports